import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/rentals`;

const rentalsService = {
  getAll: (facilityId) => apiClient.get(`${base(facilityId)}/`),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.put(`${base(facilityId)}/${id}`, data),
  // opts: { force, closeLien }
  //   force     — move out despite an outstanding balance or credit; the
  //               owed amount is zeroed and its invoices voided as bad debt.
  //   closeLien — the rental is under an active lien/auction workflow. The
  //               server refuses (409) unless this says to cancel that run,
  //               because moving out voids the invoices the claim rests on.
  end: (facilityId, id, opts = {}) => {
    const qs = [];
    if (opts && opts.force) qs.push('force=true');
    if (opts && opts.closeLien) qs.push('close_lien=true');
    return apiClient.post(
      `${base(facilityId)}/${id}/end${qs.length ? `?${qs.join('&')}` : ''}`,
    );
  },
  // Hold a rental while a reported move-out is verified: no invoices, fees,
  // autopay or system messages until it is Moved Out or resumed.
  //   pause body:  { move_out_reported_on?: 'YYYY-MM-DD', note? }
  //   resume body: { waive_missed_fees?: boolean (default true), note? }
  pause: (facilityId, id, body = {}) =>
    apiClient.post(`${base(facilityId)}/${id}/pause`, body),
  resume: (facilityId, id, body = {}) =>
    apiClient.post(`${base(facilityId)}/${id}/resume`, body),
  getAllWithArchived: (facilityId) =>
    apiClient.get(`${base(facilityId)}/?include_archived=true`),
  archive: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/archive`),
  unarchive: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/unarchive`),
};

export default rentalsService;
